<template>
  <div class="second-tab-container-inner">
    <div class="second-tab-row">
      <div class="topNav2" id="topNav2">
        <ul id="topNavUl2">
          <li v-for="(i, index) in title" :key="index" :ref="('cardSecond-' + index)"
            @click="goCenter(i.id, index, $event)">
            <div style="display: flex;flex-direction: column;align-items: center;">
              <span :class="selectindex === index ? 'title-sty' : 'untitle-sty'">{{ i.name }}</span>
            </div>
          </li>
        </ul>
      </div>
      <div @click="showAll" class="expand-btn">
        <van-icon size="0.85rem" name="arrow-down" />
      </div>
    </div>
    <div v-if="ifShow" class="pop">
      <div style="max-height: 15rem; overflow-y: scroll">
        <van-grid :border="false" :column-num="4">
          <van-grid-item v-for="(i, index) in title" :key="index">
            <div style="display: flex; flex-direction: column; align-items: center" @click="clickCard(index)">
              <span :class="selectindex === index ? 'btitle-sty' : 'noctitle-sty'">{{ i.name }}</span>
            </div>
          </van-grid-item>
        </van-grid>
      </div>
      <div @click="clossPop" class="close-pop-btn">
        <span>收起</span>
        <van-icon size="0.85rem" name="arrow-up" />
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: '',
  props: {
    title: {
      type: Array
    },
    type: {
      type: Number,
      default: 1
    },
  },
  data() {
    return {
      currentTopNav: '',
      selectindex: 0,
      ifShow: false,
      selectindex2: 0,
      getData: true
    }
  },
  created() { },
  components: {},
  methods: {
    showAll() {
      this.ifShow = true
      if (this.ifShow) {
        this.$emit('clossSecondPop')
      }
    },
    clickCard(index) {

      this.getData = true
      setTimeout(() => {
        this.$refs[('cardSecond-' + index)][0].click();
      }, 200);
    },
    indexTo(index) {
      this.getData = false
      this.$refs[('cardSecond-' + index)][0].click();
    },
    clossPop() {
      this.ifShow = false
    },
    goCenter(id, index, e) {
      if (this.ifShow) {
        this.ifShow = false
      }
      this.selectindex = index
      let destination = index - 2;
      destination = destination < 0 ? 1 : destination;
      this.currentTopNav = id;
      if (this.navScroll) {
        this.navScroll.scrollToElement(
          document.querySelector('#topNav li:nth-child(' + destination + ')')
        );
      }
      this.getdata(index);

      // 横向滑动居中
      let ul = document.querySelector('#topNavUl2');
      let nav = document.getElementById("topNav2");
      let window_offsetWidth = window.innerWidth; //屏幕宽度;
      let dom = e.target;
      if (dom && ul && nav) {
        let domoffsetWidth = dom.offsetLeft,
          //中间值 =( 屏幕宽度 - li宽度 ) / 2;
          diffWidth = (window_offsetWidth - dom.offsetWidth) / 2,
          //目标值 = offset - 中间值
          targetOffset = -(domoffsetWidth - diffWidth);
        let ul_width = ul.getBoundingClientRect().width;//开始

        // 未超出中间值
        if (-targetOffset < 0) {
          nav.scrollLeft = 0;
          return;
        }
        //末尾
        if (targetOffset < window_offsetWidth - ul_width) {
          nav.scrollLeft = -(window_offsetWidth - ul_width);
          return;
        }
        //正常
        nav.scrollLeft = -targetOffset
      }
    },
    getdata(index) {
      if (this.getData) {
        this.$emit('scrollTo', index)
      } else {
        this.getData = true
      }
    },
    getNavScrollLeft() {
      const nav = document.getElementById('topNav2');
      return nav ? nav.scrollLeft : 0;
    },
    setNavScrollLeft(scrollLeft) {
      const nav = document.getElementById('topNav2');
      if (nav && scrollLeft != null) {
        nav.scrollLeft = scrollLeft;
      }
    },

  },
  watch: {
    ifShow: function () {

    }
  },
  mounted() {
  },
}

</script>

<style lang="scss" scoped>
/* 容器样式 */
.second-tab-container-inner {
  display: flex;
  flex-direction: column;
  background-color: #fff;
  position: relative; /* 添加相对定位基准 */
  width: 100%;
}

.second-tab-row {
  display: flex;
  flex-direction: row;
  background-color: #fff;
}

/* 弹出层内的grid item包装 */
.grid-item-wrapper {
  display: flex;
  flex-direction: column;
  align-items: center;
  background-color: #fafafa;
  width: 100%;
  padding: 0.2rem 0;
}

/* 弹出层内的图标背景 - 与一级分类一致 */
.wbimagback {
  width: 2.8rem;
  height: 2.8rem;
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: white;
  border-radius: 0.6rem;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.06);
}

/* 图标图片 - 与一级分类一致 */
.img {
  width: 2.2rem;
  height: 2.2rem;
  border-radius: 0.4rem;
  object-fit: cover;
}

.topNav2 {
  background: #fff;
  display: flex;
  flex: 1;
  overflow-x: auto;
  overflow-y: hidden;
  white-space: nowrap;
  scrollbar-width: none;
  -ms-overflow-style: none;
  &::-webkit-scrollbar {
    display: none;
  }

  ul {
    display: inline-flex;
    align-items: center;
    white-space: nowrap;
    padding: 0.5rem 0.3rem;
    gap: 0.4rem;

    li {
      display: inline-block;
    }
  }
}

/* 弹出层grid样式 - 更紧凑 */
::v-deep .van-grid-item__content {
  display: flex;
  flex-direction: column;
  align-items: center;
  box-sizing: border-box;
  height: 100%;
  padding: 0.2rem 0;
  background-color: #fafafa;
}

/* 展开按钮 */
.expand-btn {
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 0;
  width: 2rem; /* 固定宽度，与一级分类一致 */
  min-width: 2rem;
  background-color: #fff;
  color: #666;
  border-left: 1px solid #eee;
}

/* 收起按钮 */
.close-pop-btn {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 0.25rem;
  padding: 0.5rem 0;
  font-size: 0.75rem;
  color: #888;
  border-top: 1px solid #eee;
  margin-top: 0.3rem;
}

/* 选中标签样式 */
.title-sty {
  border-radius: 1rem;
  background-color: rgba(231, 76, 60, 0.1);
  color: #e74c3c;
  font-size: 0.75rem;
  padding: 0.25rem 0.7rem;
  font-weight: 500;
}

/* 未选中标签样式 */
.untitle-sty {
  border-radius: 1rem;
  background-color: #fff;
  font-size: 0.75rem;
  color: #333;
  padding: 0.25rem 0.7rem;
}

/* 弹出层内未选中标签 */
.noctitle-sty {
  border-radius: 1rem;
  background-color: white;
  font-size: 0.75rem;
  color: #333;
  text-align: center;
  padding: 0.2rem 0.4rem;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  max-width: 5rem;
}

/* 弹出层内选中标签 */
.btitle-sty {
  border-radius: 1rem;
  background-color: rgba(231, 76, 60, 0.1);
  color: #e74c3c;
  font-size: 0.75rem;
  font-weight: 500;
  text-align: center;
  padding: 0.2rem 0.4rem;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  max-width: 5rem;
}

/* 弹出层容器 - 完全覆盖原有分类栏 + 动画 */
.pop {
  width: 100%;
  position: absolute;
  top: 0;
  left: 0;
  overflow-y: auto;
  z-index: 9999;
  background-color: #fff;
  border-bottom-left-radius: 1rem;
  border-bottom-right-radius: 1rem;
  padding-top: 0.5rem;
  padding-bottom: 0.5rem;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.08);
  /* 动画效果 */
  animation: slideDown 0.25s ease-out;
}

@keyframes slideDown {
  from {
    opacity: 0;
    transform: translateY(-10px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}
</style>